import i18n from '@/i18n';
import { TdsColumnGroup } from '../type';

// 异常信息
export const FORM_EXCEPTION_INFORMATION = [i18n.t('出错堆栈'), i18n.t('Issue 类型'), i18n.t('卡顿耗时（毫秒）'), i18n.t('监控粒度'), i18n.t('异常名称'), 'Issue ID', i18n.t('消息ID'),
  i18n.t('用户ID'), i18n.t('设备ID'), i18n.t('系统版本'), i18n.t('机型'), i18n.t('厂商'), i18n.t('运行时架构'), 'CPU', i18n.t('CPU架构'), 'ROM', i18n.t('前后台状态'), i18n.t('使用时长'), i18n.t('可用内存'), i18n.t('出错线程'), i18n.t('出错进程'),
  i18n.t('场景'), i18n.t('自定义字段'), i18n.t('自定义维度'), i18n.t('实验ID'), i18n.t('业务下钻'), i18n.t('个例标签'),
];

export const COLUMN_GROUP_INFO = {
  [TdsColumnGroup.UserInfo]: {
    title: i18n.t('用户信息'),
  },
  [TdsColumnGroup.ApplicationInfo]: {
    title: i18n.t('应用信息'),
  },
  [TdsColumnGroup.DeviceInfo]: {
    title: i18n.t('设备信息'),
  },
  [TdsColumnGroup.ContextInfo]: {
    title: i18n.t('现场信息'),
  },
  [TdsColumnGroup.exceptionInfo]: {
    title: i18n.t('异常信息'),
  },
  [TdsColumnGroup.Tag]: {
    title: i18n.t('平台标签'),
  },
  [TdsColumnGroup.Custom]: {
    title: i18n.t('自定义数据'),
  },
  [TdsColumnGroup.RequestInfo]: {
    title: i18n.t('请求信息'),
  },
};


